import xMark from "@/assets/xilancia-x-mark.png";

interface XMarkBackgroundProps {
  /** "light" tone targets dark backgrounds (image shows light), "dark" inverts for light backgrounds. */
  tone?: "light" | "dark";
  /** Opacity 0–1. Defaults to 0.1 (subtle). */
  opacity?: number;
  className?: string;
}

const XMarkBackground = ({
  tone = "light",
  opacity = 0.1,
  className = "",
}: XMarkBackgroundProps) => (
  <div
    aria-hidden
    className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
  >
    <img
      src={xMark}
      alt=""
      className="absolute -right-[22%] top-[32%] h-[70%] max-h-[1100px] w-auto -translate-y-1/2 select-none object-contain sm:-right-[12%] sm:top-1/2 sm:h-[95%] md:h-[120%] md:-right-[4%]"
      style={{
        opacity,
        filter: tone === "dark" ? "invert(1)" : undefined,
      }}
      draggable={false}
    />
  </div>
);

export default XMarkBackground;
